import React from 'react';
import { Card, Title } from '@tremor/react';
import StepResults from './StepResults';
import { colorTheme } from '../../../utils/constants';

const GenerateReportData = ({ canSubmit, invalidMessage, validationError, onView, onDownloadPdf, onDownloadExcel, statementType, propertyId, propertyIds, propertyName, propertyTables, multiPropertyData, tableData, columns }) => (
    <Card className="ion-margin-top full-width-card">
        <Title>Step 3: View or Download</Title>
        <div>
            <div>
                <StepResults
                    canSubmit={canSubmit}
                    invalidMessage={invalidMessage}
                    validationError={validationError}
                    onView={onView}
                    onDownloadPdf={onDownloadPdf}
                    onDownloadExcel={onDownloadExcel}
                    statementType={statementType}
                    propertyId={propertyId}
                    propertyIds={propertyIds}
                    propertyName={propertyName}
                    propertyTables={propertyTables}
                    multiPropertyData={multiPropertyData}
                    tableData={tableData}
                    columns={columns}
                    colorTheme={colorTheme}
                />
            </div>
        </div>
    </Card>
);

export default GenerateReportData;


